import { HTMLProps } from "react"
import { cn } from "@/lib/utils"

export const SelectButton = ({
	className,
	...rest
}: Omit<HTMLProps<HTMLButtonElement>, "type">) => {
	return (
		<button
			className={cn(
				className,
				"justify-start",
				"inline-flex items-center justify-start",
				"border",
				"rounded-md shadow-xs",
				"font-normal text-gray-900",
				"transition",
				"focus:ring-2 focus:ring-offset-2 focus:outline-hidden",
				"focus:ring-primary-500 border-gray-300 bg-white hover:bg-gray-50",
				"px-4 py-2 text-sm",
				"w-full",
			)}
			type="button"
			{...rest}
		/>
	)
}

export const Select = ({
	className,
	...rest
}: HTMLProps<HTMLSelectElement>) => {
	return (
		<select
			className={cn(
				className,
				"absolute top-0 right-0 bottom-0 left-0 h-full w-full cursor-pointer opacity-0",
			)}
			{...rest}
		/>
	)
}
